export default __webpack_public_path__ + "static/media/roadmap_img_m_01.df836beb.png";